import React, { useEffect } from 'react'
import './App.css'
import $ from 'jquery'
import Router from './components/Routes/index'
import ErrorBoundry from './components/ErrorBoundires/error'
import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { WalletConnectModalSign } from '@walletconnect/modal-sign-react'
function getLibrary (provider) {
  console.log(provider)
  const library = new Web3Provider(provider)
  library.pollingInterval = 12000
  return library
}
export default function () {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <App />
    </Web3ReactProvider>
  )
}

function App () {
  const projectId = 'ad0de2b56e4c0f92cfd017ca09de3ae7'
  useEffect(() => {
    

    if (
      window.performance
        .getEntriesByType('navigation')
        .map(nav => nav.type)
        .includes('reload') == true
    ) {
      alertUser()
    }

    let network = localStorage.getItem('currentNetwork')
    if (network == undefined) {
      localStorage?.setItem('currentNetwork', 'BINANCE')
      window.location.reload()
    }
    $('body').on('hidden.bs.modal', () => {
      $('#code').modal('hide')
      if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild
        Node.prototype.removeChild = function (child) {
          if (child.parentNode !== this) {
            if (console) {
              console.error(
                'Cannot remove a child from a different parent',
                child,
                this
              )
            }
            return child
          }
          return originalRemoveChild.apply(this, arguments)
        }

        const originalInsertBefore = Node.prototype.insertBefore
        Node.prototype.insertBefore = function (newNode, referenceNode) {
          if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
              console.error(
                'Cannot insert before a reference node from a different parent',
                referenceNode,
                this
              )
            }
            return newNode
          }
          return originalInsertBefore.apply(this, arguments)
        }
      }
      //   this.hideScroll(0)
    })
  }, [])

  const alertUser = e => {
    const provider = JSON.parse(localStorage.getItem('walletprovider'))
  }
  let connection = localStorage.getItem('walletconnect')
  console.log(connection)

  return (
    <ErrorBoundry>
      <div className='App'>
        <WalletConnectModalSign
          projectId={projectId}
          modalOptions={{
            themeMode: 'dark',
            enableExplorer: false,
            enableAccountView: false,
            enableNetworkView: true,
            tokenImages: {
              ETH: '/images/eth.webp',
              AVAX: '/images/avax.webp'
            },
            walletImages: {
              rainbow: '/images/rainbow.webp',
              metaMask: '/images/metamask.webp'
            },
            themeVariables: {
              '--wcm-font-family': 'Roboto, sans-serif',
              '--wcm-accent-color': '#F5841F',
              '--height-bottom': '200px'
            }
          }}
          metadata={{
            name: 'Exs Sports',
            description: 'Exs NFT marketplace',
            url: 'https://my-dapp.com',
            icons: ['https://my-dapp.com/logo.png']
          }}
        />
        <Router />
      </div>
    </ErrorBoundry>
  )
}
